export type DealProtocolErrorCode =
  | "INVALID_UNICODE_SCALAR"
  | "EMPTY_SEED"
  | "NON_CANONICAL_STRING"
  | "INTEGER_OUT_OF_RANGE"
  | "CATALOG_REVISION_NOT_FOUND"
  | "INVALID_CATALOG"
  | "NO_COMPATIBLE_THEME"
  | "NO_LINEUP"
  | "RNG_EXHAUSTED"
  | "CRYPTO_UNAVAILABLE";

export class DealProtocolError extends Error {
  readonly code: DealProtocolErrorCode;
  readonly path: string | undefined;

  constructor(
    code: DealProtocolErrorCode,
    message: string,
    path?: string
  ) {
    super(`${code}: ${message}`);
    this.name = "DealProtocolError";
    this.code = code;
    this.path = path;
  }
}

export function fail(
  code: DealProtocolErrorCode,
  message: string,
  path?: string
): never {
  throw new DealProtocolError(code, message, path);
}
